var map = {
	"./au.json": "8bcc",
	"./br.json": "d02d",
	"./cn.json": "3cc7",
	"./de.json": "28f2",
	"./fr.json": "713f",
	"./in.json": "4a66",
	"./sg.json": "0410",
	"./sx.json": "e1e4",
	"./uk.json": "3a78",
	"./us.json": "3f01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ea50";